import React, { useCallback, useState } from 'react';
import { TabsList } from '../_shared/TabsList';
import { rootLinks } from '../Links';
import styles from './Tariffs.module.scss';
import { TariffTab } from './Tariffs.type';
import { TariffsProps } from './Tariffs.type';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import TariffsRow from './TariffsRow';
import TariffsTableBlock from './TariffsTableBlock';
import StartTariffRow from './StartTariffRow';
import { tariffsDummy } from '../_dummyData/tariffs';
import { SpecialOfferModalBody } from './SpecialOffer/SpecialOfferModalBody';
import TariffsBottomText from './TariffsBottomText';

export const tabs: TariffTab[] = [
    {
        name: 'licenses',
        title: 'Лицензии стандарт',
        href: `${rootLinks.tariffs.url}/licenses`,
    },
    {
        name: 'vipLicenses',
        title: 'Лицензии VIP',
        href: `${rootLinks.tariffs.url}/vipLicenses`,
    },
];

type TariffPseudoTabsType = 'customers' | 'participants';
type PseudoTabs = {
    name: TariffPseudoTabsType;
    title: string;
}[];

const pseudoTabs: PseudoTabs = [
    {
        name: 'customers',
        title: 'Заказчикам',
    },
    {
        name: 'participants',
        title: 'Участникам',
    },
];

export const Tariffs: React.FC<TariffsProps> = React.memo(({ activeTab }) => {
    const router = useRouter();

    const [activePseudoTabName, setActivePseudoTabName] =
        useState<TariffPseudoTabsType>(
            activeTab === 'customers' ? 'customers' : 'participants'
        );

    const handlePseudoTabChange = useCallback(
        (pseudoTabName: TariffPseudoTabsType) => {
            if (pseudoTabName === activePseudoTabName) {
                return null;
            }
            if (pseudoTabName === 'customers') {
                router.push('/tariffs/customers');
                setActivePseudoTabName(pseudoTabName);
            }
            if (pseudoTabName === 'participants') {
                router.push('/tariffs/licenses');
                setActivePseudoTabName(pseudoTabName);
            }
        },
        [activePseudoTabName, router]
    );

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Тарифы</h1>
            <div className={styles.pseudoTabsList}>
                {pseudoTabs.map((pseudoTab) => {
                    const isTabActive = pseudoTab.name === activePseudoTabName;
                    return (
                        <div
                            className={clsx(
                                styles.pseudoTab,
                                isTabActive && styles.pseudoActive
                            )}
                            key={pseudoTab.name}
                            onClick={() =>
                                handlePseudoTabChange(pseudoTab.name)
                            }
                        >
                            {pseudoTab.title}
                        </div>
                    );
                })}
            </div>

            {activeTab !== 'customers' && activeTab !== 'vipLicenses' && (
                <div className={styles.specialOfferBlock}>
                    <div className={styles.specialOfferContainer}>
                        <SpecialOfferModalBody />
                    </div>
                </div>
            )}

            {activeTab !== 'customers' && (
                <div className={styles.panel}>
                    <TabsList
                        tabs={tabs}
                        url={rootLinks.tariffs.url}
                        activeTab={activeTab}
                    />
                    <div className={styles.content}>
                        {(activeTab === 'vipLicenses' ||
                            activeTab === 'licenses') && <StartTariffRow />}

                        {activeTab === 'licenses' && (
                            <TariffsTableBlock isTariffsPage>
                                {tariffsDummy.licenses.map((row, i: number) => {
                                    return (
                                        <tr key={i}>
                                            {row?.columns?.map(
                                                (column: string, i: number) => (
                                                    <td key={i}>{column}</td>
                                                )
                                            )}
                                        </tr>
                                    );
                                })}
                            </TariffsTableBlock>
                        )}

                        {activeTab === 'vipLicenses' && (
                            <TariffsTableBlock isTariffsPage isVip>
                                {tariffsDummy.vipLicenses.map(
                                    (row, i: number) => {
                                        return (
                                            <tr key={i}>
                                                {row?.columns?.map(
                                                    (
                                                        column: string,
                                                        i: number
                                                    ) => (
                                                        <td key={i}>
                                                            {column}
                                                        </td>
                                                    )
                                                )}
                                            </tr>
                                        );
                                    }
                                )}
                            </TariffsTableBlock>
                        )}

                        <TariffsBottomText
                            isVip={activeTab === 'vipLicenses'}
                        />
                    </div>
                </div>
            )}

            {activeTab === 'customers' && (
                <div className={clsx(styles.content, styles.withPaddingBottom)}>
                    <TariffsRow
                        tariffs={tariffsDummy.services.customers}
                        blockContentClassName={styles.blockContent}
                    />
                </div>
            )}
        </div>
    );
});
